import { render, staticRenderFns } from "./procurement_detail.vue?vue&type=template&id=fe6b137e&scoped=true&"
import script from "./procurement_detail.vue?vue&type=script&lang=js&"
export * from "./procurement_detail.vue?vue&type=script&lang=js&"
import style0 from "./procurement_detail.vue?vue&type=style&index=0&id=fe6b137e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6b137e",
  null
  
)

export default component.exports